import { render, staticRenderFns } from "./CustomerProfilePreferences.vue?vue&type=template&id=60e57004&scoped=true"
import script from "./CustomerProfilePreferences.vue?vue&type=script&lang=js"
export * from "./CustomerProfilePreferences.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfilePreferences.vue?vue&type=style&index=0&id=60e57004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e57004",
  null
  
)

export default component.exports